<template>
    <div class="shennandianlu">
        <div class="title">
            <b>{{ $t("case.shennandianlu.name") }}</b>
            <span>【{{ $t("case.shennandianlu.business") }}】</span>
        </div>
        <div class="business">
            <h4>{{ $t("case.shennandianlu.title") }}</h4>
            <div class="box">
                {{ $t("case.shennandianlu.details") }}
            </div>
            <div class="content">
                <div><img src="../../../public/shennandianlu.png" alt=""/></div>
                <div>
                    应用模块：IoT
                    <br>IoT：DEK印刷机、富士贴片机
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.shennandianlu {
    margin: 0px 150px;
    padding-top: 100px;
}

.title {
    font-size: 18px;
    color: #121212;
    line-height: 24px;
    padding-bottom: 40px;
    border-bottom: 1px solid #dfdfdf;
}

.title > span {
    font-size: 14px;
    color: #7e7e7c;
}

.business {
    font-size: 14px;
    color: #7e7e7c;
    line-height: 30px;
}

.business > h4 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 800;
    color: #121212;
}

.box {
    margin-bottom: 40px;
}

.content {
    display: flex;
    align-items: center;
    margin-bottom: 80px;
}

.business > .content img {
    width: 700px;
    height: 400px;
    margin-right: 80px;
}

</style>
